import { create } from 'zustand'
import type { User } from '@/types/user.types'

interface AuthState {
  user: User | null
  isAuthenticated: boolean
  isBootstrapping: boolean
}

interface AuthActions {
  login: (user: User) => void
  setUser: (user: User | null) => void
  setBootstrapping: (value: boolean) => void
  logout: () => void
}

export const useAuthStore = create<AuthState & AuthActions>()((set) => ({
  user: null,
  isAuthenticated: false,
  isBootstrapping: true,

  login: (user) =>
    set({
      user,
      isAuthenticated: true,
    }),

  setUser: (user) =>
    set({
      user,
      isAuthenticated: user !== null,
    }),

  setBootstrapping: (value) => set({ isBootstrapping: value }),

  logout: () =>
    set({
      user: null,
      isAuthenticated: false,
      isBootstrapping: false,
    }),
}))
